export const authRoutes = [ "/login", "/register", "/forgot-password", "/register/personal", "/register/business", "/register/enterprise"];
export const resetPasswordRoute = "/reset-password/";

{/* Backend Hierarchy payload converter function */}
export function transformHierarchyToBackend(data) {
  const teams = (data.children || []).map(team => {
    const members = [];

    members.push({
      first_name: team.first_name,
      last_name: team.last_name,
      email: team.email,
      role: team.role
    });

    (team.children || []).forEach(member => {
      members.push({
        first_name: member.first_name,
        last_name: member.last_name,
        email: member.email,
        role: member.role
      });
    });

    return {
      name: team.department.trim(),
      members
    };
  });

  return {
    teams
  };
}

{/* Backend Hierarchy response making able to use in tree with converter function */}
export function convertHierarchy(data) {
  if (!data || !data.company_head) {
    return {};
  }
  const { company_head, teams } = data;

  const tree = {
    first_name: company_head.first_name,
    last_name: company_head.last_name,
    email: company_head.email,
    role: "Company Head",
    department: "",
    img: company_head.profile_image || "https://cdn-icons-png.flaticon.com/512/847/847969.png",
    manual: false,
    children: []
  };

  if (Array.isArray(teams)) {
    teams.forEach(team => {
      const teamHead = team.members.find(m => m.role.toLowerCase().includes("head"));
      const teamMembers = team.members.filter(m => !m.role.toLowerCase().includes("head"));

      const headNode = {
        first_name: teamHead?.first_name || "",
        last_name: teamHead?.last_name || "",
        email: teamHead?.email || "",
        role: teamHead?.role || "Team Head",
        department: team.name,
        img: teamHead?.profile_image || "https://cdn-icons-png.flaticon.com/512/847/847969.png",
        manual: false,
        children: []
      };

      teamMembers.forEach(member => {
        headNode.children.push({
          first_name: member.first_name,
          last_name: member.last_name,
          email: member.email,
          role: "Member",
          department: team.name,
          img: member.profile_image || "https://cdn-icons-png.flaticon.com/512/847/847969.png",
          manual: false
        });
      });


      tree.children.push(headNode);
    });
  }

  return tree;
}

const SHARE_COLOR = '#AEF468';
export const accessModalStyle = `
        /* Target the Bootstrap Modal content for custom styling */
        .modal-content {
          border-radius: 1rem !important;
          border: none !important;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); /* Tailwind shadow-xl equivalent */
        }
        .modal-header {
          border-bottom: 1px solid #e5e7eb !important; /* Tailwind border-gray-200 */
          padding: 1.25rem 1.5rem !important;
        }
        .modal-body {
          padding: 1.5rem !important;
          max-height: 400px;
          overflow-y: auto;
        }
        .modal-footer {
          border-top: 1px solid #e5e7eb !important; /* Tailwind border-gray-200 */
          background-color: #f9fafb !important; /* Tailwind bg-gray-50 */
          padding: 1rem 1.5rem !important;
          display: flex; /* Ensure buttons are aligned */
          justify-content: flex-end; /* Align buttons to the right */
          gap: 0.75rem; /* Space between buttons */
        }
        
        /* Custom radio/checkbox color */
        .form-check-input:checked {
          background-color: ${SHARE_COLOR} !important;
          border-color: ${SHARE_COLOR} !important;
        }
      `





